<script lang="ts">
	export let customClass: string = '';
</script>

<!--! Font Awesome Free 7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2026 Fonticons, Inc. -->
<!-- Source: https://raw.githubusercontent.com/FortAwesome/Font-Awesome/7.3.1/svgs/solid/bars.svg -->
<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 448 512"
	width="1.25em"
	height="1em"
	class="shrink-0 {customClass}"
	aria-hidden="true"
	focusable="false"
>
	<path
		fill="currentColor"
		d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
	/>
</svg>
